import { AUTH_STORAGE_KEY, LEGACY_AUTH_STORAGE_KEYS } from './auth-storage-key.constant';
import { StoredAuthSession } from './stored-auth-session';

export type AuthStorage = Pick<Storage, 'getItem' | 'removeItem' | 'setItem'>;

export function readStoredAuthSession(storage: AuthStorage = localStorage): StoredAuthSession | null {
  const raw = storage.getItem(AUTH_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as StoredAuthSession;
  }
  catch (error) {
    console.error('Invalid stored auth session was cleared.', error);
    storage.removeItem(AUTH_STORAGE_KEY);

    return null;
  }
}

export function writeStoredAuthSession(
  session: StoredAuthSession | null,
  storage: AuthStorage = localStorage): void {
  if (session) {
    storage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
    return;
  }

  storage.removeItem(AUTH_STORAGE_KEY);
}

export function clearStoredAuthSession(storage: AuthStorage = localStorage): void {
  storage.removeItem(AUTH_STORAGE_KEY);
}

export function clearLegacyAuthStorage(storage: AuthStorage = localStorage): void {
  Object.values(LEGACY_AUTH_STORAGE_KEYS)
    .forEach((key) => { storage.removeItem(key); });
}
